/**
 * Header.js — now a proxy to the Apple/Linear-inspired PremiumNav.
 * Every page that used the old <Header /> automatically gets the new design.
 * Original legacy header preserved at Header.legacy.js for reference.
 */
import PremiumNav from "@/components/premium/PremiumNav";

export default function Header(props) {
  return <PremiumNav {...props} />;
}
